export const SAVE_FORM_DATA = 'fastcover.SAVE_FORM_DATA';
export const SAVE_FORM_DATA_SUCCESS = 'fastcover.SAVE_FORM_DATA_SUCCESS';
export const SAVE_FORM_DATA_FAIL = 'fastcover.SAVE_FORM_DATA_FAIL';
export const SUBMIT_CLAIM_SUCCESS = 'fastcover.SUBMIT_FORM_DATA_SUCCESS';
export const SUBMIT_CLAIM_FAIL = 'fastcover.SUBMIT_FORM_DATA_FAIL';

export const LOAD_FORM_DATA = 'fastcover.LOAD_FORM_DATA';
export const SUBMIT_CLAIM = 'fastcover.SUBMIT_FORM_DATA';
export const UPLOAD_CLAIM_SUMMARY = 'fastcover.UPLOAD_CLAIM_SUMMARY';

export const GET_BANK = 'fastcover.GET_BANK';
export const GET_BANK_ERROR = 'fastcover.GET_BANK_ERROR';
export const GET_BANK_SUCCESS = 'fastcover.GET_BANK_SUCCESS';
export const GETTING_BANK = 'fastcover.GETTING_BANK';
export const DOWNLOAD_CLAIM_SUMMARY = 'fastcover.DOWNLOAD_CLAIM_SUMMARY';
export const EMAIL_ME_DOCUMENTS = 'fastcover.EMAIL_ME_DOCUMENTS';
export const EMAIL_MEDICAL_TRAVEL_DOCUMENTS = 'fastcover.EMAIL_MEDICAL_TRAVEL_DOCUMENTS';
export const EMAIL_MEDICAL_ADD_DOCUMENTS = 'fastcover.EMAIL_MEDICAL_ADD_DOCUMENTS';
export const EMAIL_INTERRUPTION_DOCUMENTS = 'fastcover.EMAIL_INTERRUPTION_DOCUMENTS';
export const GET_VALIDATE_SUCCESS = 'fastcover.GET_VALIDATE_SUCCESS';
export const GET_BANK_DETAILS = 'fastcover.GET_BANK_DETAILS';
export const EMAIL_DUES_PROTECT_DOCUMENTS = 'fastcover.EMAIL_DUES_PROTECT_DOCUMENTS';
export const DOWNLOAD_ONLINE_ELECTRONIC_CONSENT_DOCUMENT = 'fastcover.DOWNLOAD_ONLINE_ELECTRONIC_CONSENT_DOCUMENT';
export const GET_COUNTRY_PAYMENT_CONFIG = 'fastcover.GET_COUNTRY_PAYMENT_CONFIG';
export const VALIDATE_FORM_DATA = 'fastcover.VALIDATE_FORM_DATA';
export const VALIDATE_CLAIM_SUCCESS = 'fastcover.VALIDATE_CLAIM_SUCCESS';
export const VALIDATE_CLAIM_FAIL = 'fastcover.VALIDATE_CLAIM_FAIL';


export const DEFAULT_CURRECY = {
  CurrencyId: 8,
  Title: 'Australian dollar',
  Symbol: 'AUD',
};

export const REQUIRED_DOCUMENT_DISPLAY_CODE = {
  OneDocRequiredPerBenefit: 'PB',
  OneDocRequiredPerBenefitExpense: 'PBE',
};

export const CURRENCY_LIST = [
  {
    CurrencyId: 149,
    Title: 'UAE dirham',
    Symbol: 'AED',
  },
  {
    CurrencyId: 1,
    Title: 'Afghan Afghani',
    Symbol: 'AFN',
  },
  {
    CurrencyId: 2,
    Title: 'Albanian lek',
    Symbol: 'ALL',
  },
  {
    CurrencyId: 6,
    Title: 'Armenian dram',
    Symbol: 'AMD',
  },
  {
    CurrencyId: 99,
    Title: 'Netherlands Antillean guilder',
    Symbol: 'ANG',
  },
  {
    CurrencyId: 4,
    Title: 'Angolan kwanza',
    Symbol: 'AOA',
  },
  {
    CurrencyId: 5,
    Title: 'Argentine peso',
    Symbol: 'ARS',
  },
  DEFAULT_CURRECY,
  {
    CurrencyId: 7,
    Title: 'Aruban guilder',
    Symbol: 'AWG',
  },
  {
    CurrencyId: 100,
    Title: 'New azerbaijani Manat',
    Symbol: 'AZN',
  },
  {
    CurrencyId: 34,
    Title: 'Convertible mark',
    Symbol: 'BAM',
  },
  {
    CurrencyId: 12,
    Title: 'Barbados dollar',
    Symbol: 'BBD',
  },
  {
    CurrencyId: 11,
    Title: 'Bangladeshi taka',
    Symbol: 'BDT',
  },
  {
    CurrencyId: 21,
    Title: 'Bulgarian lev',
    Symbol: 'BGN',
  },
  {
    CurrencyId: 10,
    Title: 'Bahraini dinar',
    Symbol: 'BHD',
  },
  {
    CurrencyId: 22,
    Title: 'Burundian franc',
    Symbol: 'BIF',
  },
  {
    CurrencyId: 15,
    Title: 'Bermudian dollar',
    Symbol: 'BMD',
  },
  {
    CurrencyId: 20,
    Title: 'Brunei dollar',
    Symbol: 'BND',
  },
  {
    CurrencyId: 17,
    Title: 'Boliviano',
    Symbol: 'BOB',
  },
  {
    CurrencyId: 19,
    Title: 'Brazilian real',
    Symbol: 'BRL',
  },
  {
    CurrencyId: 9,
    Title: 'Bahamian dollar',
    Symbol: 'BSD',
  },
  {
    CurrencyId: 16,
    Title: 'Bhutanese ngultrum',
    Symbol: 'BTN',
  },
  {
    CurrencyId: 18,
    Title: 'Botswana pula',
    Symbol: 'BWP',
  },
  {
    CurrencyId: 13,
    Title: 'Belarusian ruble',
    Symbol: 'BYR',
  },
  {
    CurrencyId: 14,
    Title: 'Belize dollar',
    Symbol: 'BZD',
  },
  {
    CurrencyId: 24,
    Title: 'Canadian dollar',
    Symbol: 'CAD',
  },
  {
    CurrencyId: 33,
    Title: 'Congolese franc',
    Symbol: 'CDF',
  },
  {
    CurrencyId: 139,
    Title: 'Swiss franc',
    Symbol: 'CHF',
  },
  {
    CurrencyId: 29,
    Title: 'Chilean peso',
    Symbol: 'CLP',
  },
  {
    CurrencyId: 30,
    Title: 'Chinese yuan renminbi (RMB)',
    Symbol: 'CNY',
  },
  {
    CurrencyId: 31,
    Title: 'Colombian peso',
    Symbol: 'COP',
  },
  {
    CurrencyId: 35,
    Title: 'Costa Rican colon',
    Symbol: 'CRC',
  },
  {
    CurrencyId: 37,
    Title: 'Cuban convertible Peso',
    Symbol: 'CUC',
  },
  {
    CurrencyId: 25,
    Title: 'Cape Verde escudo',
    Symbol: 'CVE',
  },
  {
    CurrencyId: 38,
    Title: 'Czech koruna',
    Symbol: 'CZK',
  },
  {
    CurrencyId: 40,
    Title: 'Djiboutian franc',
    Symbol: 'DJF',
  },
  {
    CurrencyId: 39,
    Title: 'Danish krone',
    Symbol: 'DKK',
  },
  {
    CurrencyId: 41,
    Title: 'Dominican peso',
    Symbol: 'DOP',
  },
  {
    CurrencyId: 3,
    Title: 'Algerian dinar',
    Symbol: 'DZD',
  },
  {
    CurrencyId: 43,
    Title: 'Egyptian pound',
    Symbol: 'EGP',
  },
  {
    CurrencyId: 44,
    Title: 'Eritrean nakfa',
    Symbol: 'ERN',
  },
  {
    CurrencyId: 45,
    Title: 'Ethipian birr',
    Symbol: 'ETB',
  },
  {
    CurrencyId: 46,
    Title: 'Euro',
    Symbol: 'EUR',
  },
  {
    CurrencyId: 48,
    Title: 'Fiji dollar',
    Symbol: 'FJD',
  },
  {
    CurrencyId: 47,
    Title: 'Falkland Islands pound',
    Symbol: 'FKP',
  },
  {
    CurrencyId: 115,
    Title: 'Pound sterling',
    Symbol: 'GBP',
  },
  {
    CurrencyId: 51,
    Title: 'Georgian lari',
    Symbol: 'GEL',
  },
  {
    CurrencyId: 55,
    Title: 'Guernsey Pound',
    Symbol: 'GGP',
  },
  {
    CurrencyId: 52,
    Title: 'Ghanaian Cedi',
    Symbol: 'GHS',
  },
  {
    CurrencyId: 53,
    Title: 'Gibraltar pound',
    Symbol: 'GIP',
  },
  {
    CurrencyId: 50,
    Title: 'Gambian dalasi',
    Symbol: 'GMD',
  },
  {
    CurrencyId: 56,
    Title: 'Guinean franc',
    Symbol: 'GNF',
  },
  {
    CurrencyId: 54,
    Title: 'Guatemalan quetzal',
    Symbol: 'GTQ',
  },
  {
    CurrencyId: 57,
    Title: 'Guyanese dollar',
    Symbol: 'GYD',
  },
  {
    CurrencyId: 60,
    Title: 'Hong Kong dollar',
    Symbol: 'HKD',
  },
  {
    CurrencyId: 59,
    Title: 'Honduran lempira',
    Symbol: 'HNL',
  },
  {
    CurrencyId: 36,
    Title: 'Croatian kuna',
    Symbol: 'HRK',
  },
  {
    CurrencyId: 58,
    Title: 'Haitian gourde',
    Symbol: 'HTG',
  },
  {
    CurrencyId: 61,
    Title: 'Hungarian forint',
    Symbol: 'HUF',
  },
  {
    CurrencyId: 64,
    Title: 'Indonesian rupiah',
    Symbol: 'IDR',
  },
  {
    CurrencyId: 67,
    Title: 'Israeli new shekel',
    Symbol: 'ILS',
  },
  {
    CurrencyId: 88,
    Title: 'Manx pound',
    Symbol: 'IMP',
  },
  {
    CurrencyId: 63,
    Title: 'Indian rupee',
    Symbol: 'INR',
  },
  {
    CurrencyId: 66,
    Title: 'Iraqi dinar',
    Symbol: 'IQD',
  },
  {
    CurrencyId: 65,
    Title: 'Iranian rial',
    Symbol: 'IRR',
  },
  {
    CurrencyId: 62,
    Title: 'Icelandic króna',
    Symbol: 'ISK',
  },
  {
    CurrencyId: 70,
    Title: 'Jersey pound',
    Symbol: 'JEP',
  },
  {
    CurrencyId: 68,
    Title: 'Jamaican dollar',
    Symbol: 'JMD',
  },
  {
    CurrencyId: 71,
    Title: 'Jordanian dinar',
    Symbol: 'JOD',
  },
  {
    CurrencyId: 69,
    Title: 'Japanese yen',
    Symbol: 'JPY',
  },
  {
    CurrencyId: 73,
    Title: 'Kenyan shilling',
    Symbol: 'KES',
  },
  {
    CurrencyId: 75,
    Title: 'Kyrgyzstani som',
    Symbol: 'KGS',
  },
  {
    CurrencyId: 23,
    Title: 'Cambodian riel',
    Symbol: 'KHR',
  },
  {
    CurrencyId: 32,
    Title: 'Comoro franc',
    Symbol: 'KMF',
  },
  {
    CurrencyId: 105,
    Title: 'North Korean won',
    Symbol: 'KPW',
  },
  {
    CurrencyId: 132,
    Title: 'South Korean won',
    Symbol: 'KRW',
  },
  {
    CurrencyId: 74,
    Title: 'Kuwaiti dinar',
    Symbol: 'KWD',
  },
  {
    CurrencyId: 26,
    Title: 'Cayman Islands dollar',
    Symbol: 'KYD',
  },
  {
    CurrencyId: 72,
    Title: 'Kazakhstani tenge',
    Symbol: 'KZT',
  },
  {
    CurrencyId: 76,
    Title: 'Lao kip',
    Symbol: 'LAK',
  },
  {
    CurrencyId: 77,
    Title: 'Lebanese pound',
    Symbol: 'LBP',
  },
  {
    CurrencyId: 134,
    Title: 'Sri Lankan rupee',
    Symbol: 'LKR',
  },
  {
    CurrencyId: 79,
    Title: 'Liberian dollar',
    Symbol: 'LRD',
  },
  {
    CurrencyId: 78,
    Title: 'Lesotho loti',
    Symbol: 'LSL',
  },
  {
    CurrencyId: 81,
    Title: 'Lithuanian litas',
    Symbol: 'LTL',
  },
  {
    CurrencyId: 80,
    Title: 'Libyan dinar',
    Symbol: 'LYD',
  },
  {
    CurrencyId: 94,
    Title: 'Moroccan dirham',
    Symbol: 'MAD',
  },
  {
    CurrencyId: 92,
    Title: 'Moldovan leu',
    Symbol: 'MDL',
  },
  {
    CurrencyId: 84,
    Title: 'Malagasy ariayry',
    Symbol: 'MGA',
  },
  {
    CurrencyId: 83,
    Title: 'Macedonian denar',
    Symbol: 'MKD',
  },
  {
    CurrencyId: 96,
    Title: 'Myanma kyat',
    Symbol: 'MMK',
  },
  {
    CurrencyId: 93,
    Title: 'Mongolian tugrik',
    Symbol: 'MNT',
  },
  {
    CurrencyId: 82,
    Title: 'Macanese pataca',
    Symbol: 'MOP',
  },
  {
    CurrencyId: 89,
    Title: 'Mauritanian ouguiya',
    Symbol: 'MRO',
  },
  {
    CurrencyId: 90,
    Title: 'Mauritian rupee',
    Symbol: 'MUR',
  },
  {
    CurrencyId: 87,
    Title: 'Maldivian rufiyaa',
    Symbol: 'MVR',
  },
  {
    CurrencyId: 85,
    Title: 'Malawian kwacha',
    Symbol: 'MWK',
  },
  {
    CurrencyId: 91,
    Title: 'Mexican peso',
    Symbol: 'MXN',
  },
  {
    CurrencyId: 86,
    Title: 'Malaysian ringgit',
    Symbol: 'MYR',
  },
  {
    CurrencyId: 95,
    Title: 'Mozambican metical',
    Symbol: 'MZN',
  },
  {
    CurrencyId: 97,
    Title: 'Namibian dollar',
    Symbol: 'NAD',
  },
  {
    CurrencyId: 104,
    Title: 'Nigerian naira',
    Symbol: 'NGN',
  },
  {
    CurrencyId: 103,
    Title: 'Nicaraguan córdoba',
    Symbol: 'NIO',
  },
  {
    CurrencyId: 106,
    Title: 'Norwegian krone',
    Symbol: 'NOK',
  },
  {
    CurrencyId: 98,
    Title: 'Nepalese rupee',
    Symbol: 'NPR',
  },
  {
    CurrencyId: 102,
    Title: 'New Zealand dollar',
    Symbol: 'NZD',
  },
  {
    CurrencyId: 107,
    Title: 'Omani rial',
    Symbol: 'OMR',
  },
  {
    CurrencyId: 109,
    Title: 'Panamanian balboa',
    Symbol: 'PAB',
  },
  {
    CurrencyId: 112,
    Title: 'Peruvian nuevo sol',
    Symbol: 'PEN',
  },
  {
    CurrencyId: 110,
    Title: 'Papua New Guinean kina',
    Symbol: 'PGK',
  },
  {
    CurrencyId: 113,
    Title: 'Philippine peso',
    Symbol: 'PHP',
  },
  {
    CurrencyId: 108,
    Title: 'Pakistani rupee',
    Symbol: 'PKR',
  },
  {
    CurrencyId: 114,
    Title: 'Polish zloty',
    Symbol: 'PLN',
  },
  {
    CurrencyId: 111,
    Title: 'Paraguayan guaraní',
    Symbol: 'PYG',
  },
  {
    CurrencyId: 116,
    Title: 'Qatari riyal',
    Symbol: 'QAR',
  },
  {
    CurrencyId: 117,
    Title: 'Romanian new Leu',
    Symbol: 'RON',
  },
  {
    CurrencyId: 125,
    Title: 'Serbian dinar',
    Symbol: 'RSD',
  },
  {
    CurrencyId: 118,
    Title: 'Russian ruble',
    Symbol: 'RUB',
  },
  {
    CurrencyId: 119,
    Title: 'Rwandan franc',
    Symbol: 'RWF',
  },
  {
    CurrencyId: 124,
    Title: 'Saudi riyal',
    Symbol: 'SAR',
  },
  {
    CurrencyId: 129,
    Title: 'Solomon Islands dollar',
    Symbol: 'SBD',
  },
  {
    CurrencyId: 126,
    Title: 'Seychelles rupee',
    Symbol: 'SCR',
  },
  {
    CurrencyId: 135,
    Title: 'Sudanese pound',
    Symbol: 'SDG',
  },
  {
    CurrencyId: 138,
    Title: 'Swedish krona',
    Symbol: 'SEK',
  },
  {
    CurrencyId: 128,
    Title: 'Singapore dollar',
    Symbol: 'SGD',
  },
  {
    CurrencyId: 120,
    Title: 'Saint Helena pound',
    Symbol: 'SHP',
  },
  {
    CurrencyId: 127,
    Title: 'Sierra Leonean leone',
    Symbol: 'SLL',
  },
  {
    CurrencyId: 130,
    Title: 'Somali shilling',
    Symbol: 'SOS',
  },
  {
    CurrencyId: 136,
    Title: 'Surinamese dollar',
    Symbol: 'SRD',
  },
  {
    CurrencyId: 133,
    Title: 'South Sudanese Pound',
    Symbol: 'SSP',
  },
  {
    CurrencyId: 123,
    Title: 'São Tomé dobra',
    Symbol: 'STD',
  },
  {
    CurrencyId: 121,
    Title: 'Salvadoran colon',
    Symbol: 'SVC',
  },
  {
    CurrencyId: 140,
    Title: 'Syrian pound',
    Symbol: 'SYP',
  },
  {
    CurrencyId: 137,
    Title: 'Swazi lilangeni',
    Symbol: 'SZL',
  },
  {
    CurrencyId: 143,
    Title: 'Thai baht',
    Symbol: 'THB',
  },
  {
    CurrencyId: 141,
    Title: 'Tajikistani somoni',
    Symbol: 'TJS',
  },
  {
    CurrencyId: 148,
    Title: 'Turkmenistani new manat',
    Symbol: 'TMT',
  },
  {
    CurrencyId: 146,
    Title: 'Tunisian dinar',
    Symbol: 'TND',
  },
  {
    CurrencyId: 144,
    Title: 'Tongan pa`anga',
    Symbol: 'TOP',
  },
  {
    CurrencyId: 147,
    Title: 'Turkish lira',
    Symbol: 'TRY',
  },
  {
    CurrencyId: 145,
    Title: 'Trinidad dollar',
    Symbol: 'TTD',
  },
  {
    CurrencyId: 101,
    Title: 'New Taiwan dollar',
    Symbol: 'TWD',
  },
  {
    CurrencyId: 142,
    Title: 'Tanzanian shilling',
    Symbol: 'TZS',
  },
  {
    CurrencyId: 151,
    Title: 'Ukrainian hryvnia',
    Symbol: 'UAH',
  },
  {
    CurrencyId: 150,
    Title: 'Ugandan shilling',
    Symbol: 'UGX',
  },
  {
    CurrencyId: 153,
    Title: 'US dollar',
    Symbol: 'USD',
  },
  {
    CurrencyId: 152,
    Title: 'Urugayan peso',
    Symbol: 'UYU',
  },
  {
    CurrencyId: 154,
    Title: 'Uzbekitan som',
    Symbol: 'UZS',
  },
  {
    CurrencyId: 156,
    Title: 'Venezualan bolivar fuerte',
    Symbol: 'VEF',
  },
  {
    CurrencyId: 157,
    Title: 'Vietnamese dong',
    Symbol: 'VND',
  },
  {
    CurrencyId: 155,
    Title: 'Vanuatu vatu',
    Symbol: 'VUV',
  },
  {
    CurrencyId: 122,
    Title: 'Samoan tala',
    Symbol: 'WST',
  },
  {
    CurrencyId: 28,
    Title: 'CFA Franc BEAC',
    Symbol: 'XAF',
  },
  {
    CurrencyId: 42,
    Title: 'East Caribbean dollar',
    Symbol: 'XCD',
  },
  {
    CurrencyId: 27,
    Title: 'CFA Franc BCEAO',
    Symbol: 'XOF',
  },
  {
    CurrencyId: 49,
    Title: 'French pacific franc',
    Symbol: 'XPF',
  },
  {
    CurrencyId: 158,
    Title: 'Yemeni rial',
    Symbol: 'YER',
  },
  {
    CurrencyId: 159,
    Title: 'Yugoslav dinar',
    Symbol: 'YUN',
  },
  {
    CurrencyId: 131,
    Title: 'South African rand',
    Symbol: 'ZAR',
  },
  {
    CurrencyId: 160,
    Title: 'Zambian kwacha',
    Symbol: 'ZMW',
  },
];

export const SCTI_COUNTRY_IDS = {
  AUSTRALIA: 14,
  NEW_ZEALAND: 155,
};




// WEBPACK FOOTER //
// ./app/containers/FastCover/constants.js